import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';

const { widthMedium } = breakpoints;
const S = {};

S.Footnote = styled.p`
  label: Footnote;

  color: var(--colors-scarpa-flow);
  margin-top: 1.5rem;

  @media (${widthMedium}) {
    margin-top: 2rem;
  }
`;

export default S;
